export default __webpack_public_path__ + "static/media/newCityMoving.30f96ba8.png";